import React, { useState, useEffect, useRef } from "react";
import { Grid, Typography, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import toast from "react-hot-toast";
import Chip from "@mui/material/Chip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import FlagIcon from "@mui/icons-material/Flag";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { colors } from "../../config/app-constants";
import { BootstrapTooltip, convertFontToSpan, timestamp } from "../../utils/services";
import Preloader from "../../helpers/Preloader";
import { apiCall } from "../../utils/action";
import TemplateEditorButton from "../button/TemplateEditorButton";
import AddDocument from "./TemplateModals/AddDocument";
import AddRating from "./TemplateModals/AddRating";
import EditGlobalRating from "./TemplateModals/EditGlobalRating";
import { Modal, Box } from "@mui/material";
import "../../../assets/styles/containers/_templateEditorLayout2.scss";
import AlertImage from "../../../assets/images/alert.png";
import moment from "moment";
import MainTemplateModal from "./TemplateModals/MainTemplateModal";
import FroalaWithoutDropdown from "../../common/froalaHtmlEditor/FroalaWithoutDropdown";
import { GetTemplateList, updateCategoryData, reorderRatings, addMultipleGlobalRating, createGlobalRating, updateGlobalRating, GetRatingsList } from "../../store/action";
import { toRatingPayload, withSequentialOrder } from "../../common/TemplateUtils/lineRatingUtils";
import { useDispatch, useSelector } from "react-redux";

const froalaConfig = {
  imagePaste: false,
  spellCheck: true,
  heightMin: 130,
  height: 130,
  heightMax: 150,
  linkAutoPrefix: 'https://',
  linkAlwaysBlank: true,
  toolbarButtons: {
    moreText: { buttons: ['bold', 'italic', 'underline', '|', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor'], align: 'left', buttonsVisible: 7 },
    moreParagraph: { buttons: ['|', 'alignLeft', 'alignCenter', 'alignRight', 'formatOLSimple', 'formatUL'], align: 'left', buttonsVisible: 8 },
    moreRich: { buttons: ['|', "insertLink", "outdent", "indent"], align: "left", buttonsVisible: 1 },
    moreMisc: { buttons: ['undo', 'redo', 'spellChecker', 'selectAll', 'html', 'clearFormatting'], align: 'right', buttonsVisible: 2 }
  },
  toolbarButtonsXS: [['fontFamily', 'fontSize', 'bold', 'italic', 'underline', '|'], ['undo', 'redo']],
  pluginsEnabled: ["wordPaste", "spellChecker", "codeBeautifier", "fontFamily", "fontSize", "colors", "align", "lists", 'paragraphFormat', "link"],
};

// Status messages for the rating actions. "Removed" is deliberately distinct from the Ratings tab's
// "deleted": removing a rating here only detaches it from this template, while deleting one in the
// comment library removes it from the company for good.
const RATING_ADDED_MESSAGE = "Rating has been added";
const RATINGS_ADDED_MESSAGE = "Ratings have been added to this template";
const RATING_UPDATED_MESSAGE = "Rating has been updated";
const RATING_REMOVED_MESSAGE = "Rating has been removed from this template";

function Details(props) {
  const {
    templateId,
    summaryEdit,
    summary,
    setSummary,
    LoadList,
    DiscardTemplateReq,
    updateTemplate,
    templateRatingDetails,
    PublishTemplate,
    templateDetails,
    TogglerSwitch,
    setAllCategoryList,
    AllCategoryList,
    autoSave,
    isAutoSaving,
    requestUpdate,
    reRender,
    setReRender,
    action,
    setAction,
    successfulRatingChange,
    defaultTemplate,
  } = props;

  const [open, setOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRating, setOpenRating] = useState(false);
  const [openEditGlobalRating, setOpenEditGlobalRating] = useState(false);
  const [templateDocument, setTemplateDocument] = useState([]);
  const [ratingName, setRatingName] = useState("");
  const [ratingNameError, setRatingNameError] = useState(false);
  const [ratingColor, setRatingColor] = useState("#82E01F");
  const [newRatingSummary, setNewRatingSummary] = useState("0");
  const [definition, setDefinition] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [deleleRatingUsed, setDeleteRatingUsed] = useState(false);
  const [defaultRatingColors, setDefaultRatingColors] = useState([]);
  const [attachStatus, setAttachStatus] = useState();
  const [attId, setattId] = useState();
  const [isDefaultTemplate, setIsDefaultTemplate] = useState(false);
  const [editId, setEditId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [createNewSite, setCreateNewSite] = React.useState(false);
  const [isCopy, setIsCopy] = useState(true);
  const [ratingArray, setRatingArray] = useState(templateRatingDetails);
  const isTexas = AllCategoryList?.template?.is_texas;
  const isSpectora = AllCategoryList?.template?.is_spectora;
  const dispatch = useDispatch();
  const editorRef = useRef();
  const parser = new DOMParser();
  const doc = parser.parseFromString(summary?.innerHTML !== undefined ? summary?.innerHTML : summary, "text/html");
  const newSummaryString = doc.body.textContent;
  const templateList=useSelector((state)=>state?.templates?.templateList);
  const ratingsPool = useSelector((state) => state?.templates?.ratingsList?.data);
  // Rating order is only meaningful while global ratings are on, so dragging stays off otherwise.
  // Texas templates never allow reordering — their rating order is fixed by the TREC form — and that
  // holds whether or not global ratings are enabled, and whether or not the template came from Spectora.
  const isGlobalRatingEnabled = !!templateList?.is_global_rating_enabled;
  const isRatingDragDisabled = isTexas || !isGlobalRatingEnabled;

  const handleChange = (name, content) => {
    setSummary({ innerHTML: content });
    setIsCopy(false);
  };

  const HandleCreateSite = () => {

    setCreateNewSite(!createNewSite);
  };

  const AddSiteDetaill = () => {
    summaryEdit();
    HandleCreateSite();
  };

  // session datas
  const companyId = sessionStorage.getItem("company_id");
  const roleId = sessionStorage.getItem("role_id");
  const uuId = sessionStorage.getItem("user_id");

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseRating = () => {
    setOpenRating(false);
  };
  const handleCloseEditGlobalRating = () => {
    setOpenEditGlobalRating(false);
  };

  const handleOpenEdits = (id) => {
    dispatch(updateCategoryData([]));
    setOpenEdit(true);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const addRating = () => {
    setAction("");
    setEditId("");
    setDeleteId("");
    setRatingName("");
    setRatingColor("#82E01F");
    setDefinition("");
    setNewRatingSummary("0");
    setIsDefaultTemplate(false);
    setOpenRating(true);
  };

  const editRating = (rating) => {
    setAction("edit");
    setEditId(rating.Id);
    setDeleteId("");
    setRatingName(rating.Name);
    setRatingColor(rating.Color);
    // A rating that arrived on the template with a library comment can be stored without its
    // definition, so the shared copy in the company pool fills the gap rather than opening blank.
    const fromPool = (ratingsPool || []).find(
      (poolRating) => String(poolRating?.id ?? poolRating?.Id) === String(rating.Id)
    );
    setDefinition(rating.Definition || fromPool?.definition || fromPool?.Definition || "");
    setNewRatingSummary(rating.include_in_summary);
    setIsDefaultTemplate(rating.is_default);
    if (templateList?.is_global_rating_enabled) {
      setOpenEditGlobalRating(true);
    } else {
      setOpenRating(true);
    }
  };

  const deleteRating = (id, used) => {
    if (used === 1) {
      setDeleteRatingUsed(true);
    }
    setAction("delete");
    setDeleteId(id);
    setOpenDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteRatingUsed(false);
  };

  function validation(tempRatingName) {
    if (tempRatingName === "" || tempRatingName === null) setRatingNameError(true);
    else setRatingNameError(false);
    if (tempRatingName !== "" && tempRatingName !== null) return true;
    else return false;
  }

  const getDefaultRatingColors = () => {
    const formdata = { company_id: companyId, user_id: uuId, role_id: roleId };
    apiCall(
      (response) => {
        // console.log("GET_DEFAULT_RATING_COLOR", response);
        const { data, message, success } = response.data;
        if (success) {
          setDefaultRatingColors(data);
          setShowLoader(false);
        } else {
          toast.error(message);
          setShowLoader(false);
          // console.log("else ", message);
        }
      },
      formdata,
      "GET_DEFAULT_RATING_COLOR"
    );
  };
  const getLargestId = (ratingsArray) => {
    let largestId = 0;
    ratingsArray.forEach((item) => {
      let id = parseInt(item.Id);
      if (id > largestId) {
        largestId = id;
      }
    });
    return largestId;
  };

  // Deleting a rating from a template with global ratings enabled only disassociates it from
  // THIS template's rating_data via the template-scoped endpoint — the global rating itself
  // (and its association with other templates) is left untouched.
  // Lines and comments store their own copy of the ratings they carry, so a deleted rating has to
  // be stripped from those selections too — otherwise it keeps showing in their rating sections.
  const removeRatingFromCategories = (categories, ratingId) => {
    const isDeleted = (rating) => String(rating?.Id ?? rating?.id) === String(ratingId);
    categories?.forEach((category) => {
      category?.lines?.forEach((line) => {
        if (Array.isArray(line.line_rating_data) && line.line_rating_data.some(isDeleted)) {
          line.line_rating_data = line.line_rating_data.filter((rating) => !isDeleted(rating));
          line.updated_at = timestamp();
        }
        if (String(line.defaultRating_id) === String(ratingId)) {
          line.defaultRating_id = null;
          line.updated_at = timestamp();
        }
        if (String(line.removed_default_rating_id) === String(ratingId)) line.removed_default_rating_id = null;
        line?.comments?.forEach((comment) => {
          if (String(comment.defaultRating_id) === String(ratingId)) {
            comment.defaultRating_id = "null";
            comment.updated_at = timestamp();
          }
          if (String(comment.removed_default_rating_id) === String(ratingId)) comment.removed_default_rating_id = null;
          comment?.comment_input_controls?.forEach((control) => {
            if (control?.type !== "Rating" || !Array.isArray(control.data)) return;
            if (!control.data.some(isDeleted)) return;
            control.data = control.data.filter((rating) => !isDeleted(rating));
            control.updated_at = timestamp();
            comment.updated_at = timestamp();
          });
        });
      });
    });
  };

  const handleDeleteGlobalRating = () => {
    setOpenDeleteModal(false);
    setDeleteRatingUsed(false);
    const remainingRatings = (ratingArray?.length > 0 ? ratingArray : []).filter(
      (rating) => String(rating.Id) !== String(deleteId)
    );
    const newCategoriesList = { ...AllCategoryList };
    removeRatingFromCategories(newCategoriesList.template?.categories, deleteId);
    const ratingData = remainingRatings.map(toRatingPayload);
    dispatch(addMultipleGlobalRating({ template_id: parseInt(templateId), rating_data: ratingData }))
      .then(() => {
        setRatingArray(remainingRatings);
        setAllCategoryList((prev) => {
          const newCategoryList = { ...prev };
          newCategoryList.template.rating_data = [...remainingRatings];
          newCategoryList.template.categories = [...newCategoriesList.template.categories];
          return newCategoryList;
        });
      })
      .then(() => {
        // Only the template association is dropped here, so the message says removed, not deleted —
        // the rating itself stays in the company's global ratings.
        toast.success(RATING_REMOVED_MESSAGE);
        updateTemplate("showToast", RATING_REMOVED_MESSAGE, true, null, successfulRatingChange);
      })
      .catch((error) => {
        toast.error(error.message || "Failed to remove rating from this template");
      });
  };

  const handleRatingUpdate = (tempRatingName, tempDefinition) => {
    let valid = validation(tempRatingName);
    let tempRatings = ratingArray?.length > 0 ? [...ratingArray] : [];
    let newCategoriesList = { ...AllCategoryList };
    if (valid) {
      handleCloseRating();
      setOpenDeleteModal(false);
      if (action === "edit") {
        let editObj = tempRatings.find((elem) => elem.Id === editId);
        if (isDefaultTemplate) {
          tempRatings.forEach((elem) => {
            if (elem.Id !== editId) elem.is_default = false;
          });
        }
        if (editObj) {
          editObj.Name = tempRatingName;
          editObj.Definition = tempDefinition;
          editObj.Color = ratingColor;
          editObj.include_in_summary = newRatingSummary;
          editObj.is_default = isDefaultTemplate;
          editObj.updated_at = timestamp();
        }
      } else if (action === "delete") {
        let deleteIndex = tempRatings.findIndex((elem) => elem.Id === deleteId);
        if (deleteIndex !== -1) tempRatings.splice(deleteIndex, 1);
        removeRatingFromCategories(newCategoriesList.template?.categories, deleteId);
      } else {
        tempRatings.push({
          Id: String(getLargestId(tempRatings) + 1),
          Name: tempRatingName,
          Color: ratingColor,
          Definition: tempDefinition,
          include_in_summary: newRatingSummary,
          is_default: isDefaultTemplate,
          updated_at: timestamp(),
        });
      }
      setRatingArray(tempRatings);
      const statusMessage =
        action === "edit" ? RATING_UPDATED_MESSAGE : action === "delete" ? RATING_REMOVED_MESSAGE : RATING_ADDED_MESSAGE;
      toast.success(statusMessage);
      updateTemplate("showToast", statusMessage, true, null, successfulRatingChange);
      setAllCategoryList((prev) => {
        const newCategoryList = { ...prev };
        newCategoryList.template.rating_data = [...tempRatings];
        newCategoryList.template.categories = [...newCategoriesList.template.categories];
        newCategoryList.template.categories.updated_at = timestamp();
        return newCategoryList;
      });
    }
  };

  const handleSaveGlobalRatingAsNew = async (tempRatingName, tempDefinition) => {
    const valid = validation(tempRatingName);
    if (!valid) return;
    const trimmedName = tempRatingName.trim();
    const includeInSummary = parseInt(newRatingSummary) === 1 ? 1 : 0;

    // Rating names are unique per company. Reusing an existing name here (most commonly the
    // name of the rating being edited, if the user didn't change it) makes the backend resolve
    // the "new" rating to the SAME id as the existing one, which then overwrites it instead of
    // creating a distinct copy.
    const preCheckList = await dispatch(GetRatingsList()).catch(() => null);
    const preCheckRatings = preCheckList?.data?.data || [];
    const nameTaken = preCheckRatings.some(
      (r) => (r.name || "").trim().toLowerCase() === trimmedName.toLowerCase()
    );
    if (nameTaken) {
      setRatingNameError(true);
      toast.error("A rating with this name already exists. Please use a different name to save as new.");
      return;
    }
    setRatingNameError(false);

    dispatch(
      createGlobalRating({
        name: trimmedName,
        color: ratingColor,
        definition: tempDefinition,
        include_in_summary: includeInSummary,
      })
    )
      .then(async (data) => {
        const existingIds = (ratingArray?.length > 0 ? ratingArray : []).map((r) => String(r.Id ?? r.id));
        let newRatingId = parseInt(data?.data?.id);
        if (!newRatingId) {
          const listResponse = await dispatch(GetRatingsList());
          const allRatings = listResponse?.data?.data || [];
          const created = [...allRatings]
            .reverse()
            .find(
              (r) =>
                (r.name || "").trim().toLowerCase() === trimmedName.toLowerCase() &&
                !existingIds.includes(String(r.id))
            );
          newRatingId = parseInt(created?.id);
        }
        if (!newRatingId || existingIds.includes(String(newRatingId))) {
          throw new Error("Failed to determine the id of the newly created rating");
        }
        const newRatingPayload = {
          Id: newRatingId,
          Name: trimmedName,
          Color: ratingColor,
          Definition: tempDefinition,
          include_in_summary: includeInSummary,
          is_default: isDefaultTemplate ? 1 : 0,
          order: null,
        };
        // Replace the rating being edited with the new fork in THIS template's list — the
        // original global rating itself is left untouched so other templates using it are unaffected.
        const otherRatings = (ratingArray?.length > 0 ? ratingArray : []).filter(
          (rating) => String(rating.Id) !== String(editId)
        );
        const existingRatings = otherRatings.map(toRatingPayload);
        const ratingData = withSequentialOrder([...existingRatings, newRatingPayload]);
        return dispatch(addMultipleGlobalRating({ template_id: parseInt(templateId), rating_data: ratingData })).then(() => {
          const tempRatings = [...otherRatings];
          if (isDefaultTemplate) {
            tempRatings.forEach((elem) => {
              elem.is_default = false;
            });
          }
          const merged = withSequentialOrder([...tempRatings, newRatingPayload]);
          setRatingArray(merged);
          setAllCategoryList((prev) => {
            const newCategoryList = { ...prev };
            newCategoryList.template.rating_data = [...merged];
            return newCategoryList;
          });
        });
      })
      .then(() => {
        handleCloseEditGlobalRating();
        toast.success(RATING_ADDED_MESSAGE);
        updateTemplate("showToast", RATING_ADDED_MESSAGE, true, null, successfulRatingChange);
      })
      .catch((error) => {
        toast.error(error.message || "Failed to add rating");
      });
  };

  const handleUpdateGlobalRating = (tempRatingName, tempDefinition) => {
    const valid = validation(tempRatingName);
    if (!valid) return;
    const trimmedName = tempRatingName.trim();
    const includeInSummary = parseInt(newRatingSummary) === 1 ? 1 : 0;

    const tempRatings = withSequentialOrder(ratingArray?.length > 0 ? [...ratingArray] : []);
    const editObj = tempRatings.find((elem) => String(elem.Id) === String(editId));
    if (!editObj) return;
    if (isDefaultTemplate) {
      tempRatings.forEach((elem) => {
        elem.is_default = String(elem.Id) === String(editId) ? 1 : 0;
      });
    }
    editObj.Name = trimmedName;
    editObj.Definition = tempDefinition;
    editObj.Color = ratingColor;
    editObj.include_in_summary = includeInSummary;
    editObj.is_default = isDefaultTemplate ? 1 : 0;
    editObj.updated_at = timestamp();

    // The edited fields (name/color/definition) always belong to the shared global rating, so
    // that's updated directly. is_default is per-template, so the template-scoped endpoint (the
    // same one "Add rating" uses) is always posted too — posting it only when the rating is being
    // marked default left the flag set on the server when the toggle was switched back off.
    dispatch(
      updateGlobalRating(editId, {
        name: trimmedName,
        color: ratingColor,
        definition: tempDefinition,
        include_in_summary: includeInSummary,
        is_default: isDefaultTemplate ? 1 : 0,
      })
    )
      .then(() =>
        dispatch(
          addMultipleGlobalRating({ template_id: parseInt(templateId), rating_data: tempRatings.map(toRatingPayload) })
        )
      )
      .then(() => {
        setRatingArray(tempRatings);
        setAllCategoryList((prev) => {
          const newCategoryList = { ...prev };
          newCategoryList.template.rating_data = [...tempRatings];
          return newCategoryList;
        });
      })
      .then(() => {
        handleCloseEditGlobalRating();
        toast.success(RATING_UPDATED_MESSAGE);
        updateTemplate("showToast", RATING_UPDATED_MESSAGE, true, null, successfulRatingChange);
      })
      .catch((error) => {
        toast.error(error.message || "Failed to update rating");
      });
  };

  const reorderRatingsList = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleRatingDragEnd = (result) => {
    if (isRatingDragDisabled) return;
    if (!result.destination || result.destination.index === result.source.index) return;
    const previousRatingArray = ratingArray;
    // The new `order` has to be written onto the ratings themselves, not just their position in
    // the array: the list is re-sorted by `order` on the way back through EditTemplate, so leaving
    // the old values on them put the panel straight back into the order it was dragged out of.
    const reordered = withSequentialOrder(
      reorderRatingsList(ratingArray, result.source.index, result.destination.index)
    );
    setRatingArray(reordered);
    setAllCategoryList((prev) => {
      const newCategoryList = { ...prev };
      newCategoryList.template.rating_data = [...reordered];
      return newCategoryList;
    });
    const ratingData = reordered.map((rating) => ({ Id: parseInt(rating.Id), order: rating.order }));
    dispatch(reorderRatings({ template_id: parseInt(templateId), rating_data: ratingData }))
      .then(() => {
        updateTemplate("showToast", "Ratings have been reordered", true, null, successfulRatingChange);
      })
      .catch((error) => {
        setRatingArray(previousRatingArray);
        setAllCategoryList((prev) => {
          const newCategoryList = { ...prev };
          newCategoryList.template.rating_data = [...previousRatingArray];
          return newCategoryList;
        });
        toast.error(error.message || "Failed to reorder ratings");
      });
  };

  // The list comes back sorted by `order`, and a freshly added rating carries none — a null
  // order sorts ahead of the numbered ones, which is why new ratings reappeared at the top
  // after a refresh. Renumber by position (same 1-based scheme handleRatingDragEnd persists)
  // so whatever is last in the array stays last.
  // `withSequentialOrder` / `toRatingPayload` are shared with the comment-library insert, which
  // posts the same list when a library comment brings in a rating the template doesn't have.

  const handleAddMultipleGlobalRatings = (selectedRatings) => {
    return new Promise((resolve, reject) => {
      const existingRatings = (ratingArray?.length > 0 ? ratingArray : []).map(toRatingPayload);
      const newRatings = selectedRatings.map((rating) => ({ ...toRatingPayload(rating), order: null }));
      const ratingData = [...existingRatings, ...newRatings];
      dispatch(addMultipleGlobalRating({ template_id: parseInt(templateId), rating_data: ratingData }))
        .then(() => {
          const tempRatings = ratingArray?.length > 0 ? [...ratingArray] : [];
          const merged = [...tempRatings, ...newRatings];
          setRatingArray(merged);
          setAllCategoryList((prev) => {
            const newCategoryList = { ...prev };
            newCategoryList.template.rating_data = [...merged];
            return newCategoryList;
          });
          toast.success(RATINGS_ADDED_MESSAGE);
          updateTemplate("showToast", RATINGS_ADDED_MESSAGE, true, null, successfulRatingChange);
          resolve();
        })
        .catch((error) => {
          toast.error(error.message || "Failed to add ratings to this template");
          reject(error);
        });
    });
  };

  useEffect(() => {
    getDefaultRatingColors();
  }, [reRender]);

  useEffect(() => {
    setRatingArray(templateRatingDetails);
  }, [templateRatingDetails]);

  useEffect(() => {
    if(!templateList)dispatch(GetTemplateList({ company_id: companyId, user_id: uuId, role_id: roleId }));
  }, [templateList]);

  // Needed to fill in a definition the template's own rating list is missing — see `editRating`.
  useEffect(() => {
    if (!isGlobalRatingEnabled || ratingsPool?.length) return;
    dispatch(GetRatingsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGlobalRatingEnabled]);

  return (
    <>
      <Preloader showPreloader={showLoader} />
      {/* Add document modal */}
      <AddDocument
        handleClose={handleClose}
        open={open}
        setOpen={setOpen}
        LoadList={LoadList}
        templateId={templateId}
        companyId={companyId}
        uuId={uuId}
        roleId={roleId}
        attachments={attachments}
        attId={attId}
        attachStatus={attachStatus}
        templateDocument={templateDocument}
        setTemplateDocument={setTemplateDocument}
      />
      {/* Add rating modal */}
      <AddRating
        openRating={openRating}
        setOpenRating={setOpenRating}
        handleCloseRating={handleCloseRating}
        ratingName={ratingName}
        setRatingName={setRatingName}
        definition={definition}
        setDefinition={setDefinition}
        rating_colors={defaultRatingColors}
        ratingColor={ratingColor}
        setRatingColor={setRatingColor}
        newRatingSummary={newRatingSummary}
        setNewRatingSummary={setNewRatingSummary}
        templateId={templateId}
        handleRatingUpdate={handleRatingUpdate}
        onAddGlobalRatings={handleAddMultipleGlobalRatings}
        isDefaultTemplate={isDefaultTemplate}
        setIsDefaultTemplate={setIsDefaultTemplate}
        ratingNameError={ratingNameError}
        isGREnabled={templateList?.is_global_rating_enabled}
        isEditMode={action === "edit"}
        existingRatingIds={(ratingArray || []).map((rating) => parseInt(rating.Id))}
      />
      {/* Edit global rating modal */}
      <EditGlobalRating
        open={openEditGlobalRating}
        onClose={handleCloseEditGlobalRating}
        ratingName={ratingName}
        setRatingName={setRatingName}
        definition={definition}
        setDefinition={setDefinition}
        ratingColor={ratingColor}
        setRatingColor={setRatingColor}
        newRatingSummary={newRatingSummary}
        setNewRatingSummary={setNewRatingSummary}
        isDefaultTemplate={isDefaultTemplate}
        setIsDefaultTemplate={setIsDefaultTemplate}
        onUpdate={handleUpdateGlobalRating}
        onSaveAsNew={handleSaveGlobalRatingAsNew}
        ratingNameError={ratingNameError}
      />
      {/* delete modal */}
      <Dialog open={openDeleteModal} onClose={closeDeleteModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" className="delete-alert-modal">
        <DialogTitle id="alert-dialog-title">
          {"Delete rating?"}
          <CloseIcon className="close-icon" onClick={closeDeleteModal} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {deleleRatingUsed
              ? "This rating is used as a default rating for some comments in your template.\nDeleting the rating will remove the default rating for those comments."
              : "This action cannot be undone."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="delete-modal-cancel-btn" onClick={closeDeleteModal}>
            Cancel
          </Button>
          <Button
            className="default-btn"
            variant="contained"
            color="error"
            onClick={templateList?.is_global_rating_enabled ? handleDeleteGlobalRating : handleRatingUpdate}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* delete modal end */}
      <div className="status status-container">
        <div className="status__layout status_wrapper">
          {/* default toggle button */}
          <div className="default_toggler mb-23">
            <div>
              <span style={{ display: "flex", alignItems: "center" }}>
                {defaultTemplate === 0 ? (
                  <ToggleOffIcon
                    id="default_template_off"
                    onClick={() => TogglerSwitch(1)}
                    style={{
                      fontSize: "36px",
                      color: "#BEBEBE",
                      cursor: "pointer",
                      marginRight: "7px",
                    }}
                  />
                ) : (
                  <ToggleOnIcon
                    onClick={() => TogglerSwitch(0)}
                    id="default_template_on"
                    style={{
                      fontSize: "36px",
                      cursor: "pointer",
                      color: "#239D80",
                      marginRight: "7px",
                    }}
                  />
                )}
                <span id="te-setasdefault" style={{ fontSize: "14px", color: "#333333" }}>
                  {" "}
                  Set as default template
                </span>
              </span>
              {/* <span>Set as default template</span> */}
            </div>
            <p>Your default template will be displayed first automatically.</p>
          </div>
          {/* status chip */}
          <div className="status_chip mb-23">
            <div>
              <span className="status-head">Status:</span>
              <span>
                <Chip
                  sx={{
                    // backgroundColor: colors[`${props.status.status.toUpperCase()}_BG`],
                    backgroundColor:
                      templateDetails.is_published === 0 ? colors[`UNPUBLISHED_CHANGES_BG`] : templateDetails.is_published === 2 ? colors[`UNPUBLISHED_CHANGES_BG`] : colors[`PUBLISHED_BG`],
                    // color: colors[`${props.status.status.toUpperCase()}`],
                    color: templateDetails.is_published === 0 ? colors[`UNPUBLISHED_CHANGES`] : templateDetails.is_published === 2 ? colors[`UNPUBLISHED_CHANGES`] : colors[`PUBLISHED`],
                    height: "18px",
                  }}
                  label={
                    <h4 className="chip_text">
                      {templateDetails.is_published === 0 ? "unpublished changes" : templateDetails.is_published === 2 ? "Publish In-progress" : "published"}
                      {/* {props.status.status} */}
                    </h4>
                  }
                />
              </span>
            </div>
            <p>
              {templateDetails.is_published === 0
                ? "This template contains unpublished changes. Until changes are published, they will not appear in new inspections."
                : "This template is published and ready for use."}
            </p>
            {/* <p>This template contains unpublished changes. Until changes are published, they will not appear in new inspections. </p> */}
          </div>
          {/* attachment  */}
          {/* <div className="attachment mb-23">
            <p>
              Attachments
              <span>
                <BootstrapTooltip
                  title={
                    <h1 className="font-13">
                      Use attachments to include additional files or information
                      with the inspection report when it is published.
                    </h1>
                  }
                >
                  <InfoOutlinedIcon className="info-icon" />
                </BootstrapTooltip>
              </span>
            </p>
            <div className="attachment_list">
              {templateDetails?.attachments?.map((elem, index) => {
                return (
                  <div key={index}>
                    <div className="attachment_list_item">
                      <span className="doc_title">{elem.file_name}</span>
                      <span className="list_action">
                        <span>
                          <BootstrapTooltip
                            onClick={() =>
                              addAttachmentModal(true, "edit", elem.id)
                            }
                            title={<h1 className="font-13">Edit details</h1>}
                          >
                            <EditIcon className="edit-icon" />
                          </BootstrapTooltip>
                        </span>
                        <span>
                          <BootstrapTooltip
                            title={<h1 className="font-13">Delete record</h1>}
                          >
                            <DeleteIcon className="delete-icon" />
                          </BootstrapTooltip>
                        </span>
                      </span>
                    </div>
                    <a href={elem.s3_url} target="_blank" download>
                      <span className="attachments">
                        <FileDownloadIcon /> {elem.s3_url.split("/")[3]}
                      </span>
                    </a>
                  </div>
                );
              })}
            </div>
            <div
              className="add_section"
              onClick={() => addAttachmentModal(true, "add")}
            >
              <ControlPointIcon className="add-icon" />
              Add attachment
            </div>
          </div> */}
          {/* Rating */}
          {AllCategoryList?.template?.is_narrative_template === 1 ? null : (
            <>
              <div className="rating_section mb-23">
                <p className="rating_header_row">
                  <span className="rating_label">
                    {/* A Texas template's ratings are fixed by the TREC form, so it reads as a plain
                        "Ratings" list even on a company that has global ratings enabled. */}
                    {isGlobalRatingEnabled && !isTexas ? "Global Ratings" : "Ratings"}
                    <span>
                      <BootstrapTooltip title={<h1 className="font-13">Your rating choices. Flag icon will be sent to summary.</h1>}>
                        <InfoOutlinedIcon className="info-icon" />
                      </BootstrapTooltip>
                    </span>
                  </span>
                </p>
                <DragDropContext onDragEnd={handleRatingDragEnd}>
                  <Droppable droppableId="ratings-droppable">
                    {(provided) => (
                      <div className="ratings_list" ref={provided.innerRef} {...provided.droppableProps}>
                        {ratingArray?.map((rating, index) => {
                          const draggableId = `rating-${rating.Id ?? index}`;
                          return (
                            <Draggable key={draggableId} draggableId={draggableId} index={index} isDragDisabled={isRatingDragDisabled}>
                              {(dragProvided, dragSnapshot) => (
                                <div
                                  className={`rating_wrapper${dragSnapshot.isDragging ? " rating_wrapper_dragging" : ""}`}
                                  ref={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                >
                                  <div className="rating_square_wrapper">
                                    {!isRatingDragDisabled && (
                                      <span className="rating_drag_handle" {...dragProvided.dragHandleProps}>
                                        <DragIndicatorIcon />
                                      </span>
                                    )}
                                    <div className="rating_square" style={{ background: `${rating.Color}` }}>
                                      {(rating.include_in_summary === "1" || rating.include_in_summary === 1) && <FlagIcon />}
                                    </div>
                                    <span>
                                      {rating?.Name?.length > 25 ? `${rating.Name.substring(25, 0)}...` : rating.Name}
                                      {(rating.is_default === "1" || rating.is_default === 1) && templateList?.is_global_rating_enabled ? (
                                        <span className="rating_default_label"> (Default)</span>
                                      ) : null}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      pointerEvents: isTexas && !isSpectora ? "none" : "auto",
                                      opacity: isTexas && !isSpectora ? "0.7" : 1,
                                    }}
                                    className="list_action"
                                  >
                                    <span>
                                      <BootstrapTooltip sx={{ pointerEvents: "none" }} title={<h1 className="font-13">Edit details</h1>}>
                                        <EditIcon
                                          id={`te-${rating?.Name}edit`}
                                          className="edit-icon"
                                          onClick={() => {
                                            editRating(rating, rating.Id);
                                          }}
                                        />
                                      </BootstrapTooltip>
                                    </span>
                                    <span>
                                      <BootstrapTooltip sx={{ pointerEvents: "none" }} title={<h1 className="font-13">Delete from template</h1>}>
                                        <DeleteIcon
                                          className="delete-icon"
                                          id={`te-${rating?.Name}delete`}
                                          onClick={() => {
                                            deleteRating(rating.Id, rating?.is_selected);
                                          }}
                                        />
                                      </BootstrapTooltip>
                                    </span>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                {isTexas && !isSpectora ? null : (
                  <div
                    style={{
                      pointerEvents: isTexas && !isSpectora ? "none" : "auto",
                      opacity: isTexas && !isSpectora ? "0.7" : 1,
                    }}
                    className="add_section mt-10"
                    onClick={addRating}
                    id="add_rating_btn"
                  >
                    <ControlPointIcon className="add-icon" />
                    Add rating
                  </div>
                )}
              </div>
            </>
          )}
          <div className="rating_section mt-34">
            <div className="rating_wrapper" style={{ alignItems: "center" }}>
              <p>Summary Disclaimer</p>
              <a onClick={() => HandleCreateSite()} style={{ marginBottom: "9px" }}>
                <span
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    color: "#4282e2",
                    fontWeight: "600 !important",
                  }}
                  className="attachments"
                >
                  <EditIcon
                    sx={{
                      fontSize: "12px !important",
                      position: "relative",
                      top: "2px",
                      right: "2px",
                    }}
                  />
                  {"Edit text"}
                </span>
              </a>
            </div>
            <div className="rating_wrapper">
              <span style={{ fontSize: "14px !important", overflow: "hidden" }}>{newSummaryString?.length > 100 ? `${newSummaryString?.substring(100, 0)}...` : newSummaryString}</span>
            </div>
          </div>
          {/* Action buttons */}
          <div className="status_actions">
            <div className="status_cta">
              {templateDetails.version !== 0 && templateDetails.is_published === 0 && <TemplateEditorButton btnType="cta_normal" text="Discard draft" action={handleOpenEdits} />}
              <TemplateEditorButton
                id="te-savechangesbutton"
                btnType="cta_normal"
                disabled={!autoSave}
                text={isAutoSaving ? "Currently saving..." : autoSave ? "Save changes" : "No changes to save"}
                action={(e) => {
                  e.stopPropagation();
                  requestUpdate();
                }}
              />
              <TemplateEditorButton id="te-saveandpublishbutton" btnType="cta_filled" text="Save and publish" action={PublishTemplate} />
            </div>
            <div className="last_save_notify">
              <p>Last autosave: {moment(templateDetails.updated_at).calendar()}</p>
              <p>Changes to these settings only affect future reports.</p>
            </div>
          </div>
        </div>
      </div>

      <MainTemplateModal
        createNewSite={createNewSite}
        currentTemplateId={templateId}
        title={"Summary Disclaimer"}
        type={"summary"}
        LoadList={LoadList}
        templateDetails={templateDetails}
        HandleCreateSite={HandleCreateSite}
        AllCategoryList={AllCategoryList}
        updateTemplate={updateTemplate}
        onModalClose={() => setCreateNewSite(false)}
        actions={{
          AddSiteDetaill: () => AddSiteDetaill()
        }}
        innerTemplate={
          <>
            <div
              className="te-editor-container"
              style={{
                height: "235px",
                width: "100%",
                marginTop: "29px",
                marginLeft: "16px",
                borderBottom: "1px solid #dadada",
              }}
            >
              <p className="line-sub-head">Introductory text</p>
              <FroalaWithoutDropdown
                copy={isCopy}
                showAI={false}
                commentData={summary}
                editorData={convertFontToSpan(summary)}
                editor={editorRef}
                id={"summary-disclaimer"}
                onChange={handleChange}
                froalaConfig={froalaConfig}
              />
            </div>
          </>
        }
      />

      <Modal open={openEdit} onClose={handleCloseEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className={"inspection-filter-modal-main"}>
        <Box className={"inspection-filter-modal"} sx={{ maxWidth: "655px !important" }}>
          <Grid container>
            <Grid item xs={12}>
              <CloseIcon sx={{ float: "right", cursor: "pointer" }} onClick={handleCloseEdit} />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center", mt: "60px" }}>
              <img src={AlertImage} alt="alert" style={{ width: "51px", height: "49px" }} />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  color: "#333333",
                  fontFamily: "open sans",
                  fontSize: "22px",
                  mt: "15px",
                  letterSpacing: 0,
                }}
              >
                {`The template: `}
                {<b style={{ fontSize: "22px", wordWrap: "break-word" }}>{templateDetails?.name} </b>}
                {` has not been published`}
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  color: "#333333",
                  fontFamily: "open sans",
                  fontSize: "14px",
                  mt: "15px",
                  letterSpacing: 0,
                }}
              >
                If you continue, any work you have done will be lost. Do you want to continue and discard the work you have done?{" "}
              </Typography>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "right",
                mt: 8,
                mr: "34px",
                pb: "25px",
              }}
            >
              <Button variant="outlined" className="inspection-filter-modal-buttons-cancel" sx={{ width: "119px" }} onClick={handleCloseEdit}>
                Cancel
              </Button>
              <Button variant="contained" className="inspection-filter-modal-buttons-apply" sx={{ width: "119px", ml: 3 }} onClick={() => DiscardTemplateReq()}>
                Ok
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

export default Details;